import { act } from "react-dom/test-utils";
import { ChangePasswordTypes } from "../globals/types"

var initState = {
    is_loading: false,
    data: null
}

export const changePasswordReducer = (state = initState, action) => {
    switch (action.type) {
        case ChangePasswordTypes.OPERATION_IN_PROGRESS:
            return {
                ...state,
                is_loading: action.is_loading,
                data: action.data
            }
        case ChangePasswordTypes.OPERATION_DONE:
            return {
                ...state,
                is_loading: action.is_loading,
                data: action.data
            }
        default:
            return {...state}
    }
}